import { render } from "./empAssesment.vue?vue&type=template&id=1789f4a5&scoped=true"
import script from "./empAssesment?vue&type=script&lang=js"
export * from "./empAssesment?vue&type=script&lang=js"

import "./empAssesment.vue?vue&type=style&index=0&id=1789f4a5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1789f4a5"]])

export default __exports__